import { createUrl } from "@/redux/api";
import {
  UpdateMembershipRequest,
  MembershipResponse,
  MembershipQueryParams,
  Tags,
} from "@/redux/memberships/types";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const membershipsService = (builder: BuilderType<Tags>) => ({
  getMemberships: builder.query<
    MembershipResponse[] | PaginatedResponse<MembershipResponse>,
    MembershipQueryParams
  >({
    query: (filters) => ({
      url: createUrl("/memberships/", filters),
      method: "GET",
    }),
    providesTags: (result) =>
      result
        ? (
            (isPaginatedResponse(result)
              ? result.results
              : result) as MembershipResponse[]
          ).map((i) => ({
            type: "Membership",
            id: i.id,
          }))
        : [],
  }),
  patchMembershipById: builder.mutation<
    MembershipResponse,
    { id: number; data: UpdateMembershipRequest }
  >({
    query: ({ id, data }) => ({
      url: `/memberships/${id}/`,
      method: "PATCH",
      data,
    }),
    invalidatesTags: (result) =>
      result ? [{ type: "Membership", id: result.id }] : [],
  }),
  deleteMembershipById: builder.mutation<null, number>({
    query: (id) => ({
      url: `/memberships/${id}/`,
      method: "DELETE",
    }),
    invalidatesTags: (_, error, args) =>
      error ? [] : [{ type: "Membership", id: args }],
  }),
});

export default membershipsService;
